/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { httpGetLanguageAvailableLanguages, httpPostUserUpdateLanguage } from '@zvoove-market/api';
import { AutoFormArray } from '@zvoove/components/utils';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private http = inject(HttpClient);

  public availableLanguages$ = httpGetLanguageAvailableLanguages(this.http).pipe(shareReplay(1));

  public switchLanguage(languageCode: string): void {
    httpPostUserUpdateLanguage(this.http, { body: { language: languageCode } }).subscribe(() => {
      window.location.reload();
    });
  }

  public copyDefaultLangInputsToOtherInputs(internationalizationFormArray: AutoFormArray, formKeysToCopy: string[]) {
    const defaultLangFormGroup = internationalizationFormArray.at(0);
    for (let idx = 1; idx < internationalizationFormArray.length; idx++) {
      const langFormGroup = internationalizationFormArray.at(idx);
      const copyFormValueIfEmpty = (value: string) => {
        const languagePropValue = langFormGroup.value[value];
        if ((Array.isArray(languagePropValue) && !languagePropValue.length) || !languagePropValue)
          langFormGroup.get(value)?.setValue(defaultLangFormGroup.value[value]);
      };
      formKeysToCopy.map(copyFormValueIfEmpty);
    }
  }
}
